<template>
    <div>
        <!-- 定时购白名单设置抽屉（需求 7121828104：支持批量导入和下载已导入的文件） -->
        <el-drawer
            title="定时购白名单设置"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
            append-to-body
        >
            <div class="drawer-content">
                <el-alert type="warning" :closable="false" class="MB10">
                    <div slot="title">开启白名单后，仅手机号在白名单内的用户订单参与定时购抽签；白名单为空时全部订单都不执行占库存</div>
                </el-alert>

                <!-- 搜索区 -->
                <div class="page-filter-box">
                    <el-row :gutter="20">
                        <el-col :span="14">
                            <el-input v-model="params.mobile" size="small" clearable placeholder="请输入手机号搜索" @keyup.enter.native="search"></el-input>
                        </el-col>
                        <el-col :span="10" class="page-filter-btns">
                            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                        </el-col>
                    </el-row>
                </div>

                <!-- 操作按钮区 -->
                <div class="page-btns-box">
                    <el-button type="primary" plain size="small" @click="out('', 1)" icon="el-icon-remove-outline">批量移除白名单</el-button>
                    <el-button type="primary" plain size="small" @click="$refs.importWhitelist.show(sku)" icon="el-icon-upload2">批量导入</el-button>
                    <el-button type="primary" plain size="small" @click="download" :loading="downLoading" icon="el-icon-download">下载已导入的白名单</el-button>
                </div>

                <!-- 白名单列表 -->
                <div class="page-list-box">
                    <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
                        @selection-change="handleSelectionChange">
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column prop="id" label="ID" width="80"></el-table-column>
                        <el-table-column prop="mobile" label="手机号" min-width="130"></el-table-column>
                        <el-table-column prop="createTime" label="导入时间" min-width="160"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="out(scope.row.id, 2)">移除白名单</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- 分页 -->
                <div v-if="data" class="page-pagination-box">
                    <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                        :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                        layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                    </el-pagination>
                </div>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">关闭</el-button>
            </div>

            <!-- 批量导入抽屉 -->
            <import-whitelist ref="importWhitelist" @onUpdate="getDataList()"></import-whitelist>
        </el-drawer>
    </div>
</template>

<script>
// 定时购票品白名单设置（列表+批量导入+下载，交互参考 whiteList.vue）
import { downloadFileTmp } from '@/assets/js/commonApi.js';
import ImportWhitelist from './pre-buy-whitelist-import.vue';
// 默认搜索参数
const defaultParams = {
    pageNo: 1,
    pageSize: 10,
    mobile: '',
}
export default {
    components: { ImportWhitelist },
    data() {
        return {
            drawerShow: false,
            listLoading: false,
            downLoading: false,
            data: null,      // 分页返回对象
            dataList: [],    // 白名单列表
            whiteListIds: [], // 已勾选的白名单记录ID
            params: { ...defaultParams },
            sku: {},         // 当前票品
            skuId: '',       // 票品ID
        }
    },
    methods: {
        // 打开抽屉（传入票品行数据）
        show(row) {
            this.sku = row;
            this.skuId = row.id;
            this.getDataList();
            this.drawerShow = true;
        },
        // 关闭抽屉并重置
        close() {
            this.params = { ...defaultParams };
            this.data = null;
            this.dataList = [];
            this.whiteListIds = [];
            this.drawerShow = false;
        },
        // 获取白名单列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: '/preBuyWhitelist/pageList',
                method: 'POST',
                data: {
                    ...this.params,
                    skuId: this.skuId
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        // 修改每页条数
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        // 搜索（重置页码）
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        // 重置搜索
        reset() {
            this.params = { ...defaultParams, pageSize: this.params.pageSize };
            this.getDataList();
        },
        // 表格勾选变化（批量移除用）
        handleSelectionChange(val) {
            this.whiteListIds = val.map(v => v.id);
        },
        // 移除白名单 type==1 批量移除 type==2 单个移除
        out(id, type) {
            if (type == 1 && this.whiteListIds.length < 1) {
                return this.$message.warning('请选择需要移除的手机号');
            }
            const _ids = type == 1 ? [...this.whiteListIds] : [id];
            this.$confirm('注意：移除白名单后，该手机号用户的订单将不再参与定时购抽签', '确定要移除白名单吗？', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/preBuyWhitelist/remove',
                    method: 'POST',
                    data: {
                        skuId: this.skuId,
                        ids: _ids
                    },
                }).then(res => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$message.success('移除成功');
                        this.getDataList();
                    } else {
                        this.$message.error(msg || '移除失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            }).catch(() => { });
        },
        // 下载已导入的白名单（当前票品全量）
        async download() {
            this.downLoading = true;
            const res = await this.$request({
                url: '/preBuyWhitelist/export',
                method: 'POST',
                params: {
                    skuId: this.skuId
                },
            }).catch(() => {
                this.$message.error('请求错误');
                this.downLoading = false;
            });
            if (!res) return;
            const { state, msg, result } = res.data;
            if (state == 1 && result && result.url) {
                // 文件名使用 演出id-票品名称
                const _fileName = `${this.$route.params.id || ''}-${this.sku.ticketName || this.skuId}`;
                await downloadFileTmp(result.url, `定时购白名单_${_fileName}.` + this.$utils.getFileType(result.url));
            } else {
                this.$message.error(msg || '下载失败');
            }
            this.downLoading = false;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
